import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import * as Api from "../General/api";
import * as Common from "../General/common";

const NpiTab = ({ onDoctorsFetched, setIsLoading, resetSignal }) => {
  const [npi, setNPI] = useState("");
  const [infoMsg, setInfoMsg] = useState(""); // inline message

  useEffect(() => {
    setNPI("");
      setInfoMsg("");
      var test = onDoctorsFetched?.([]);
  }, [resetSignal]);

  const handleNPIChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setNPI(value);
  };
    const handleFocus = () => {
        setInfoMsg("");
        var test = onDoctorsFetched?.([]); // Clear grid when user starts typing again
    };
  const handleSearch = async () => {
    const body = { npi: npi ? parseInt(npi) : null, firstName: null, lastName: null };

    if (!npi || npi.length !== 10) {
      setInfoMsg("Enter a valid 10-digit NPI");
      return;
    }

    try {
      var test = setIsLoading?.(true);
      const res = await Api.postRequest(Api.URI_FetchPhysicianList, body);

      if (res?.data?.success) {
        const list = res.data.result || [];
        var test = onDoctorsFetched?.(list);
        setInfoMsg(list.length === 0 ? "No matching records found" : "");
      } else {
        setInfoMsg(res?.data?.message);
      }
    } catch {
      setInfoMsg("No matching records found");
    } finally {
      var test = setIsLoading?.(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && npi?.length === 10) handleSearch();
  };

  const fieldWidth = 200;

  return (
    <div className="mx-auto" style={{ maxWidth: 540 }}>
      <div
        className="d-flex flex-column align-items-center"
        style={{ gap: 12 }}
        onKeyDown={onKeyDown}
      >
        <div className="d-flex align-items-end justify-content-center" style={{ gap: 12 }}>
          <div style={{ width: fieldWidth }}>
            <input
              type="text"
              name="npi"
              id="npi"
              className="form-control form-control-sm"
              value={npi}
                          onChange={handleNPIChange}
                          onFocus={handleFocus}
              autoComplete="off"
              placeholder="10-digit NPI"
            />
          </div>
          <div style={{ paddingBottom: 2 }}>
            <Button
              type="button"
              size="sm"
              variant="primary"
              disabled={npi.length !== 10}
              onClick={handleSearch}
              style={{ minWidth: 82 }}
            >
              Search
            </Button>
          </div>
        </div>

              {/* Inline message */}
              {infoMsg && (
                    <div style={{ marginTop: 8, display: "flex", justifyContent: "center", width: "100%" }}>
                        <div
                            role="status"
                            aria-live="polite"
                            style={{
                                display: "inline-flex",
                                alignItems: "flex-start",
                                gap: 4,
                                padding: "4px 8px",
                                borderRadius: 8,
                                backgroundColor: "#FDECEC",
                                border: "1px solid #F4C9C9",
                                color: "#7E1C1C",
                                fontSize: 12,
                                lineHeight: 1.3,
                                fontWeight: 500,
                                letterSpacing: "0.1px",
                                fontFamily: "inherit",
                                boxShadow: "0 1px 2px rgba(0,0,0,.04)",
                                maxWidth: 560,
                            }}
                        >
                            <span aria-hidden="true" style={{ display: "inline-flex", paddingTop: '1px' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" fill="#FDECEC" stroke="#B43434" strokeWidth="1.8" />
                                    <path d="M12 7.2v7.2" stroke="#B43434" strokeWidth="1.8" strokeLinecap="round" />
                                    <circle cx="12" cy="17.5" r="1.35" fill="#B43434" />
                                </svg>
                            </span>
                            <span style={{ whiteSpace: "normal", textAlign: 'left' }}>{infoMsg}</span>
                        </div>
                    </div>
                )}
      </div>
    </div>
  );
};

export default NpiTab;
